import { useEffect, useState } from "react";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import { SERVER_URL } from "../config";

interface Provider {
  id: string;
  firstName: string;
  lastName: string;
  licenseNumber: string;
  region: string;
  createdAt: string;
  licenses: {
    licenseNumber: string;
    licenseState: string;
  };
  user: {
    email: string;
  };
  clinic: {
    id: string;
    clinicName: string;
    address: string;
    phone: string;
    region: string;
    clinicCode: string;
  };
  userId: string;
}

const useProviderProfile = () => {
  const [provider, setProvider] = useState<Provider | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      console.error("No token found in local storage");
      window.location.href =
        "/provider-sign-in?message=Session expired, please log in again";
      return;
    }

    const fetchProvider = async () => {
      try {
        const response = await fetchWithAuth(
          `${SERVER_URL}/api/provider/profile`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch provider profile");
        }

        const data = await response.json();
        setProvider(data);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchProvider();
  }, []);

  return { provider, loading, error };
};

export default useProviderProfile;
